"use strict";
/*
 * Created on 23.05.2020
 *
 * Copyright (c) 2020 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var big_decimal_1 = require("@logio/big-decimal");

var immutable_1 = require("immutable");

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");

var DataDictionaryError_1 = require("../../../core/model/data-dictionary/DataDictionaryError");

var utils_1 = require("../../../core/utils");

var KpiSetSpec_1 = require("../../../kpi/KpiSetSpec");

var PromotionWeekType_1 = require("../../../promotion/enums/PromotionWeekType");

var PerformanceReportData_1 = require("../../../report/promoperf/model/PerformanceReportData");

var SupplierAgreement_1 = require("../../../supply/model/SupplierAgreement");

var MemberCreditsConverterImpl_1 = require("../../../window/conversions/MemberCreditsConverterImpl");

var MemberCredits_1 = require("../../../window/model/MemberCredits");

var PosTypeEnum_1 = require("../../../window/model/PosTypeEnum");

var Window_1 = require("../../../window/model/Window");

var WindowItem_1 = require("../../../window/model/WindowItem");

var WindowItemPosAttributes_1 = require("../../../window/model/WindowItemPosAttributes");

var PromotionPerformanceReportDataConverter_1 = require("./PromotionPerformanceReportDataConverter"); // tslint:disable-next-line:max-classes-per-file


var PerfPromotionConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PerfPromotionConverter, _DataObjectConverter_);

  function PerfPromotionConverter() {
    _classCallCheck(this, PerfPromotionConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PerfPromotionConverter).apply(this, arguments));
  }

  _createClass(PerfPromotionConverter, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new PerformanceReportData_1.PerfPromotion(PerformanceReportData_1.PerfPromotion.schema.id.valueOf(conversions.documentToClassId(source)), utils_1.Utils.isValueMissing(source.externalId) ? '' : PerformanceReportData_1.PerfPromotion.schema.externalId.valueOfField(source), utils_1.Utils.isValueMissing(source.workflowState) ? null : PerformanceReportData_1.PerfPromotion.schema.workflowState.valueOfField(source), utils_1.Utils.isValueMissing(source.name) ? '' : PerformanceReportData_1.PerfPromotion.schema.name.valueOfField(source), utils_1.Utils.isValueMissing(source.promotionTypeId) ? utils_1.Utils.VOID_ID : PerformanceReportData_1.PerfPromotion.schema.promotionTypeId.valueOf(conversions.toClassReferenceId(source.promotionTypeId)), PerformanceReportData_1.PerfPromotion.schema.storeSpecification.valueOfField(source), PerformanceReportData_1.PerfPromotion.schema.dateFrom.valueOfField(source), PerformanceReportData_1.PerfPromotion.schema.dateTo.valueOfField(source), utils_1.Utils.isValueMissing(source.gosId) ? utils_1.Utils.VOID_ID : PerformanceReportData_1.PerfPromotion.schema.gosId.valueOf(conversions.toClassReferenceId(source.gosId)));
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        workflowState: source.workflowState,
        name: source.name,
        promotionTypeId: source.promotionTypeId === utils_1.Utils.VOID_ID ? utils_1.Utils.VOID_ID : conversions.toDocumentReferenceId(source.promotionTypeId),
        storeSpecification: source.storeSpecification,
        dateFrom: conversions.fromDate(source.dateFrom),
        dateTo: conversions.fromDate(source.dateTo),
        gosId: source.gosId === utils_1.Utils.VOID_ID ? utils_1.Utils.VOID_ID : conversions.toDocumentReferenceId(source.gosId)
      });
      return result;
    }
  }]);

  return PerfPromotionConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PerfPromotionConverter = PerfPromotionConverter; // tslint:disable-next-line:max-classes-per-file

var PerfWindowConverter =
/*#__PURE__*/
function (_DataObjectConverter_2) {
  _inherits(PerfWindowConverter, _DataObjectConverter_2);

  function PerfWindowConverter() {
    _classCallCheck(this, PerfWindowConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PerfWindowConverter).apply(this, arguments));
  }

  _createClass(PerfWindowConverter, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new PerformanceReportData_1.PerfWindow(Window_1.Window.schema.id.valueOf(conversions.documentToClassId(source)), Window_1.Window.schema.workflowState.valueOfField(source), Window_1.Window.schema.name.valueOfField(source), !utils_1.Utils.isValueMissing(source.windowOriginId) ? conversions.toClassReferenceId(source.windowOriginId) : null, Window_1.Window.schema.windowTypeId.valueOf(conversions.toClassReferenceId(source.windowTypeId)), !utils_1.Utils.isValueMissing(source.mergedWindowIds) ? conversions.asClassReferenceIdsList(source, 'mergedWindowIds') : immutable_1.List(), Window_1.Window.schema.dateFrom.valueOfField(source), Window_1.Window.schema.dateTo.valueOfField(source), Window_1.Window.schema.themeId.valueOf(source.themeId ? conversions.toClassReferenceId(source.themeId) : null), !utils_1.Utils.isValueMissing(source.promotionId) ? Window_1.Window.schema.promotionId.valueOf(conversions.toClassReferenceId(source.promotionId)) : utils_1.Utils.VOID_ID, !utils_1.Utils.isValueMissing(source.fcApprovalNeeded) ? source.fcApprovalNeeded : false, Window_1.Window.schema.portfolio.valueOf(conversions.toClassReferenceId(source.portfolio)), Window_1.Window.schema.dummy.valueOfField(source), utils_1.Utils.isValueMissing(source.simAttrs) ? immutable_1.List() : conversions.asObjectList(source, 'simAttrs', function (v) {
        return v;
      }));
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        workflowState: source.workflowState,
        name: source.name,
        windowOriginId: source.windowOriginId !== null ? conversions.toDocumentReferenceId(source.windowOriginId) : null,
        windowTypeId: conversions.toDocumentReferenceId(source.windowTypeId),
        mergedWindowIds: source.mergedWindowIds.map(function (windowId) {
          return conversions.toDocumentReferenceId(windowId);
        }).toArray(),
        dateFrom: conversions.fromDate(source.dateFrom),
        dateTo: conversions.fromDate(source.dateTo),
        themeId: source.themeId !== null ? conversions.toDocumentReferenceId(source.themeId) : null,
        promotionId: source.promotionId !== null && source.promotionId !== utils_1.Utils.VOID_ID ? conversions.toDocumentReferenceId(source.promotionId) : null,
        fcApprovalNeeded: source.fcApprovalNeeded,
        portfolio: conversions.toDocumentReferenceId(source.portfolio),
        dummy: source.dummy,
        simAttrs: source.simAttrs.toArray()
      });
      return result;
    }
  }]);

  return PerfWindowConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PerfWindowConverter = PerfWindowConverter; // tslint:disable-next-line:max-classes-per-file

var PerfWindowItemPosAttributesConverter =
/*#__PURE__*/
function (_DataObjectConverter_3) {
  _inherits(PerfWindowItemPosAttributesConverter, _DataObjectConverter_3);

  function PerfWindowItemPosAttributesConverter() {
    _classCallCheck(this, PerfWindowItemPosAttributesConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PerfWindowItemPosAttributesConverter).apply(this, arguments));
  }

  _createClass(PerfWindowItemPosAttributesConverter, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new PerformanceReportData_1.PerfWindowItemPosAttributes(WindowItemPosAttributes_1.WindowItemPosAttributes.schema.posMarginImpactExpected.valueOf(utils_1.Utils.isValueMissing(source.posMarginImpactExpected) ? null : conversions.toBigNumber(source.posMarginImpactExpected)), WindowItemPosAttributes_1.WindowItemPosAttributes.schema.posMechanics.valueOf(utils_1.Utils.isValueMissing(source.posMechanics) ? null : source.posMechanics), WindowItemPosAttributes_1.WindowItemPosAttributes.schema.posType.valueOf(utils_1.Utils.isValueMissing(source.posType) ? PosTypeEnum_1.PosTypeEnum.None : source.posType));
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      result = Object.assign(result, {
        posMarginImpactExpected: conversions.fromBigNumber(source.posMarginImpactExpected),
        posMechanics: utils_1.Utils.isValueMissing(source.posMechanics) ? null : source.posMechanics,
        posType: source.posType
      });
      return result;
    }
  }]);

  return PerfWindowItemPosAttributesConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PerfWindowItemPosAttributesConverter = PerfWindowItemPosAttributesConverter; // tslint:disable-next-line:max-classes-per-file

var PerfWindowItemConverter =
/*#__PURE__*/
function (_DataObjectConverter_4) {
  _inherits(PerfWindowItemConverter, _DataObjectConverter_4);

  function PerfWindowItemConverter() {
    var _this;

    _classCallCheck(this, PerfWindowItemConverter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PerfWindowItemConverter).apply(this, arguments));
    _this.posAttributesConverter = new PerfWindowItemPosAttributesConverter();
    _this.memberCreditsConverter = new MemberCreditsConverterImpl_1.MemberCreditsConverterImpl();
    return _this;
  }

  _createClass(PerfWindowItemConverter, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new PerformanceReportData_1.PerfWindowItem(WindowItem_1.WindowItem.schema.id.valueOf(conversions.documentToClassId(source)), WindowItem_1.WindowItem.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), WindowItem_1.WindowItem.schema.windowId.valueOf(conversions.toClassReferenceId(source.windowId)), WindowItem_1.WindowItem.schema.promotionId.valueOf(conversions.toClassReferenceId(source.promotionId)), this.posAttributesConverter.toObject(source.posAttributes, conversions), utils_1.Utils.isValueMissing(source.memberCredits) ? MemberCredits_1.MemberCredits.EMPTY : this.memberCreditsConverter.toObject(source.memberCredits, conversions), WindowItem_1.WindowItem.schema.promoPrice.valueOf(conversions.toBigNumber(source.promoPrice)), WindowItem_1.WindowItem.schema.regularPrice.valueOf(conversions.toBigNumber(source.regularPrice)), WindowItem_1.WindowItem.schema.promoVolume.valueOf(conversions.toBigNumber(source.promoVolume)), utils_1.Utils.isValueMissing(source.simulationId) ? null : source.simulationId, utils_1.Utils.isValueMissing(source.snapshot) ? false : source.snapshot, source.fcApprovalNeeded, source.requestForSecondaryPlacement, source.secondaryPlacement, source.onPicture, source.numberOfSites, utils_1.Utils.isValueMissing(source.simAttrs) ? immutable_1.List() : conversions.asObjectList(source, 'simAttrs', function (v) {
        return v;
      }), WindowItem_1.WindowItem.schema.logisticComment.valueOf(source.logisticComment));
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        productId: conversions.toDocumentReferenceId(source.productId),
        windowId: conversions.toDocumentReferenceId(source.windowId),
        promotionId: conversions.toDocumentReferenceId(source.promotionId),
        posAttributes: this.posAttributesConverter.toDocument(source.posAttributes, conversions),
        memberCredits: this.memberCreditsConverter.toDocument(source.memberCredits, conversions),
        promoPrice: conversions.fromBigNumber(source.promoPrice),
        regularPrice: conversions.fromBigNumber(source.regularPrice),
        promoVolume: conversions.fromBigNumber(source.promoVolume),
        simulationId: source.simulationId,
        snapshot: source.snapshot,
        fcApprovalNeeded: source.fcApprovalNeeded,
        requestForSecondaryPlacement: source.requestForSecondaryPlacement,
        secondaryPlacement: source.secondaryPlacement,
        onPicture: source.onPicture,
        numberOfSites: source.numberOfSites,
        simAttrs: source.simAttrs.toArray(),
        logisticComment: source.logisticComment
      });
      return result;
    }
  }]);

  return PerfWindowItemConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PerfWindowItemConverter = PerfWindowItemConverter; // tslint:disable-next-line:max-classes-per-file

var PerfSupplierAgreementConverter =
/*#__PURE__*/
function (_DataObjectConverter_5) {
  _inherits(PerfSupplierAgreementConverter, _DataObjectConverter_5);

  function PerfSupplierAgreementConverter() {
    _classCallCheck(this, PerfSupplierAgreementConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PerfSupplierAgreementConverter).apply(this, arguments));
  }

  _createClass(PerfSupplierAgreementConverter, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      var documentId = utils_1.Utils.VOID_ID;

      try {
        documentId = conversions.documentToClassId(source);
      } catch (ex) {// This can occur for synthesized supplier agreement that has no id available (WindowItemSimulation.synthesizeAgreement)
      }

      return new PerformanceReportData_1.PerfSupplierAgreement(documentId, SupplierAgreement_1.SupplierAgreement.schema.supplierId.valueOf(conversions.toClassReferenceId(source.supplierId)), SupplierAgreement_1.SupplierAgreement.schema.currencyId.valueOf(conversions.toClassReferenceId(source.currencyId)), SupplierAgreement_1.SupplierAgreement.schema.windowItemId.valueOf(conversions.toClassReferenceId(source.windowItemId)), SupplierAgreement_1.SupplierAgreement.schema.preferred.valueOfField(source), SupplierAgreement_1.SupplierAgreement.schema.regularPurchasePrice.valueOf(utils_1.Utils.isValueMissing(source.regularPurchasePrice) ? null : conversions.toBigNumber(source.regularPurchasePrice)), SupplierAgreement_1.SupplierAgreement.schema.promoPurchasePrice.valueOf(utils_1.Utils.isValueMissing(source.promoPurchasePrice) ? null : conversions.toBigNumber(source.promoPurchasePrice)), SupplierAgreement_1.SupplierAgreement.schema.promoPurchasePricePlus.valueOf(utils_1.Utils.isValueMissing(source.promoPurchasePricePlus) ? null : conversions.toBigNumber(source.promoPurchasePricePlus)), SupplierAgreement_1.SupplierAgreement.schema.promoPurchaseStartDate.valueOf(utils_1.Utils.isValueMissing(source.promoPurchaseStartDate) ? null : conversions.toDate(source.promoPurchaseStartDate)), SupplierAgreement_1.SupplierAgreement.schema.promoPurchaseEndDate.valueOf(utils_1.Utils.isValueMissing(source.promoPurchaseEndDate) ? null : conversions.toDate(source.promoPurchaseEndDate)), SupplierAgreement_1.SupplierAgreement.schema.promoVolume.valueOf(conversions.toBigNumber(source.promoVolume)), SupplierAgreement_1.SupplierAgreement.schema.secondaryPlacementFee.valueOf(utils_1.Utils.isValueMissing(source.secondaryPlacementFee) ? null : conversions.toBigNumber(source.secondaryPlacementFee)), SupplierAgreement_1.SupplierAgreement.schema.leafletFee.valueOf(utils_1.Utils.isValueMissing(source.leafletFee) ? null : conversions.toBigNumber(source.leafletFee)), SupplierAgreement_1.SupplierAgreement.schema.costPriceFormat.valueOfField(source), SupplierAgreement_1.SupplierAgreement.schema.unitBackDiscount.valueOf(utils_1.Utils.isValueMissing(source.unitBackDiscount) ? null : conversions.toBigNumber(source.unitBackDiscount)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {}; // null document id can occur for synthesized supplier agreement that has no id available (WindowItemSimulation.synthesizeAgreement)

      var documentIdDoc = conversions.classToDocumentId(source);

      if (documentIdDoc !== null) {
        result = Object.assign(result, documentIdDoc);
      }

      result = Object.assign(result, {
        supplierId: conversions.toDocumentReferenceId(source.supplierId),
        currencyId: conversions.toDocumentReferenceId(source.currencyId),
        windowItemId: conversions.toDocumentReferenceId(source.windowItemId),
        preferred: source.preferred,
        regularPurchasePrice: source.regularPurchasePrice === null ? null : conversions.fromBigNumber(source.regularPurchasePrice),
        promoPurchasePrice: source.promoPurchasePrice === null ? null : conversions.fromBigNumber(source.promoPurchasePrice),
        promoPurchasePricePlus: source.promoPurchasePricePlus === null ? null : conversions.fromBigNumber(source.promoPurchasePricePlus),
        promoPurchaseStartDate: source.promoPurchaseStartDate === null ? null : conversions.fromDate(source.promoPurchaseStartDate),
        promoPurchaseEndDate: source.promoPurchaseEndDate === null ? null : conversions.fromDate(source.promoPurchaseEndDate),
        promoVolume: conversions.fromBigNumber(source.promoVolume),
        secondaryPlacementFee: source.secondaryPlacementFee === null ? null : conversions.fromBigNumber(source.secondaryPlacementFee),
        leafletFee: source.leafletFee === null ? null : conversions.fromBigNumber(source.leafletFee),
        costPriceFormat: source.costPriceFormat,
        unitBackDiscount: source.unitBackDiscount ? conversions.fromBigNumber(source.unitBackDiscount) : null
      });
      return result;
    }
  }]);

  return PerfSupplierAgreementConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PerfSupplierAgreementConverter = PerfSupplierAgreementConverter; // tslint:disable-next-line:max-classes-per-file

var WeeklySplitRecipeConverter =
/*#__PURE__*/
function (_DataObjectConverter_6) {
  _inherits(WeeklySplitRecipeConverter, _DataObjectConverter_6);

  function WeeklySplitRecipeConverter() {
    _classCallCheck(this, WeeklySplitRecipeConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WeeklySplitRecipeConverter).apply(this, arguments));
  }

  _createClass(WeeklySplitRecipeConverter, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      if (!utils_1.Utils.isObject(source.weights)) {
        throw new DataDictionaryError_1.DataDictionaryError('weights object is missing in ' + JSON.stringify(source));
      }

      var weights = immutable_1.Map().asMutable();

      for (var id in source.weights) {
        if (source.weights.hasOwnProperty(id)) {
          weights.set(id, // TODO: Store and load weights more precisely as BigDecimals, not as numbers
          immutable_1.List(utils_1.Utils.asArray(source.weights[id]).map(utils_1.Utils.asNumber)).map(function (n) {
            return big_decimal_1.bigdecimal(n);
          }));
        }
      }

      var kpiSpec = utils_1.Utils.asArray(source.kpiSpec).map(utils_1.Utils.asString);

      if (kpiSpec.length !== 3) {
        throw new DataDictionaryError_1.DataDictionaryError('kpiSpec array is invalid in ' + JSON.stringify(source));
      }

      var thresholds = immutable_1.List(utils_1.Utils.asArray(source.thresholds).map(utils_1.Utils.asString));
      var phases = immutable_1.Set(utils_1.Utils.asArray(source.phases).map(function (p) {
        return utils_1.Utils.asString(p);
      }));
      var weekType = utils_1.Utils.asString(source.weekType || PromotionWeekType_1.PromotionWeekType.Promo);
      return {
        kpiSpec: kpiSpec,
        phases: phases,
        thresholds: thresholds,
        weights: weights,
        weekType: weekType
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      var weights = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = source.weights[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              id = _step$value[0],
              ln = _step$value[1];

          // TODO: Store and load weights more precisely as BigDecimals, not as numbers
          weights[id] = ln.map(function (b) {
            return b.toNumber();
          }).toArray();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      result = Object.assign(result, {
        kpiSpec: KpiSetSpec_1.KpiSetSpec.expandKpiSpec(source.kpiSpec),
        phases: source.phases.toArray(),
        thresholds: source.thresholds.toArray(),
        weekType: source.weekType,
        weights: weights
      });
      return result;
    }
  }]);

  return WeeklySplitRecipeConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WeeklySplitRecipeConverter = WeeklySplitRecipeConverter;
/**
 * @author Radek Beran
 */
// tslint:disable-next-line:max-classes-per-file

var PromotionPerformanceReportDataConverterImpl =
/*#__PURE__*/
function (_PromotionPerformance) {
  _inherits(PromotionPerformanceReportDataConverterImpl, _PromotionPerformance);

  function PromotionPerformanceReportDataConverterImpl() {
    var _this2;

    _classCallCheck(this, PromotionPerformanceReportDataConverterImpl);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(PromotionPerformanceReportDataConverterImpl).apply(this, arguments));
    _this2.perfPromotionConverter = new PerfPromotionConverter();
    _this2.perfWindowConverter = new PerfWindowConverter();
    _this2.perfWindowItemConverter = new PerfWindowItemConverter();
    _this2.perfSupplierAgreementConverter = new PerfSupplierAgreementConverter();
    _this2.weeklySplitRecipeConverter = new WeeklySplitRecipeConverter();
    return _this2;
  }
  /**
   * @inheritDoc
   */


  _createClass(PromotionPerformanceReportDataConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this3 = this;

      var supplierAgreementList = conversions.asObjectList(source, 'supplierAgreements', function (doc) {
        return _this3.perfSupplierAgreementConverter.toObject(doc, conversions);
      });
      return new PerformanceReportData_1.PromotionPerformanceReportData(conversions.documentToClassId(source), source.forSnapshot, source.forSimulation, this.perfPromotionConverter.toObject(source.promotion, conversions), !utils_1.Utils.isValueMissing(source.promotionWeeklySplits) ? conversions.asObjectList(source, 'promotionWeeklySplits', function (doc) {
        return _this3.weeklySplitRecipeConverter.toObject(doc, conversions);
      }) : immutable_1.List(), conversions.asObjectList(source, 'windows', function (doc) {
        return _this3.perfWindowConverter.toObject(doc, conversions);
      }), conversions.asObjectList(source, 'windowItems', function (doc) {
        return _this3.perfWindowItemConverter.toObject(doc, conversions);
      }), supplierAgreementList.groupBy(function (sa) {
        return sa.windowItemId;
      }).map(function (l) {
        return l.toList();
      }).toMap());
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this4 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var agreements = source.supplierAgreements.valueSeq().flatten().map(function (a) {
        return _this4.perfSupplierAgreementConverter.toDocument(a, conversions);
      }).toArray();
      var result = {};
      result = Object.assign(result, conversions.classToDocumentId(source));
      result = Object.assign(result, {
        forSnapshot: source.forSnapshot,
        forSimulation: source.forSimulation,
        promotion: this.perfPromotionConverter.toDocument(source.promotion, conversions),
        promotionWeeklySplits: conversions.asObjectArray(source, 'promotionWeeklySplits', function (item) {
          return _this4.weeklySplitRecipeConverter.toDocument(item, conversions);
        }),
        windows: conversions.asObjectArray(source, 'windows', function (item) {
          return _this4.perfWindowConverter.toDocument(item, conversions);
        }),
        windowItems: conversions.asObjectArray(source, 'windowItems', function (item) {
          return _this4.perfWindowItemConverter.toDocument(item, conversions);
        }),
        supplierAgreements: agreements
      });
      return result;
    }
  }]);

  return PromotionPerformanceReportDataConverterImpl;
}(PromotionPerformanceReportDataConverter_1.PromotionPerformanceReportDataConverter);

exports.PromotionPerformanceReportDataConverterImpl = PromotionPerformanceReportDataConverterImpl;